import { QueryParams } from "@/models/query-params.model";
import { StatsRest } from "@/services/rest/stats.rest";
import { BehaviorSubject, map, take } from "rxjs";

export class ObjectiveService {
  constructor(private _stats = new StatsRest()) {}

  private objectives$ = new BehaviorSubject<any>([]);
  objectives = this.objectives$.asObservable();

  getObjectivesFromCourse(courseId: string, params?: QueryParams): void {
    this._stats
      .getObjectivesFromCourse(courseId, params)
      .pipe(
        take(1),
        map((e) => {
          e.content.forEach((item) => {
            item.quizAverage =
              item.quizAverage == 0 ? " - " : String(item.quizAverage);
          });
          return e;
        })
      )
      .subscribe({
        next: (response) => {
          this.objectives$.next(response);
        },
      });
  }
}
